import { ContentfulEntry } from '@jbhi-fi/apis/src/contentful/types';

export const useContentMetafieldData = <T extends ContentfulEntry<any>>(): T & { isFullData: boolean } => {
  const fullData = window?.Jbhifi?.decompressedContentfulData;
  if (fullData) {
    return {
      sys: fullData.sys,
      metadata: fullData.metadata,
      fields: fullData.fields,
      isFullData: true,
    } as T & { isFullData: boolean };
  }

  const skeletonData = window?.Jbhifi?.contentfulData;
  if (!skeletonData) {
    throw new Error('Could not find contentful data on window');
  }
  return {
    sys: skeletonData.sys,
    metadata: skeletonData.metadata,
    fields: skeletonData.fields,
    isFullData: false,
  } as T & { isFullData: boolean };
};
